import api from '@/api'

export const getters = {
  sponsorsWithUsers() {
    return this.sponsors
      .map((sponsor) => {
        const user = this.users[sponsor.userId]
        const { userId, ...sponsorWithoutUserId } = sponsor
        const available = sponsor.active && this.isSponsorAvailable(sponsor)
        return { user, available, ...sponsorWithoutUserId }
      })
      .sort((a, b) => (a.user.name < b.user.name ? -1 : 1))
  },

  isSponsor(state) {
    return state.sponsors.map((sponsor) => sponsor.userId).includes(state.currentUserId)
  },

  isSponsorAvailable() {
    return (sponsor) => {
      const amountOfSponsorships = this.getSponsorshipsFromUserId(sponsor.userId).length
      return amountOfSponsorships < sponsor.limit && sponsor.active
    }
  },
}

export const actions = {
  async fetchSponsors() {
    this.sponsors = await api.fetchSponsors()
  },

  async saveNewSponsor(sponsorDetails) {
    await api.saveSponsor(sponsorDetails)
    await this.fetchSponsors()
  },

  async updateSponsor(sponsorDetails) {
    await api.updateSponsor(sponsorDetails)
    await this.fetchSponsors()
  },

  async deleteSponsor(sponsorDetails) {
    await api.deleteSponsor(sponsorDetails)
    await this.fetchSponsors()
    await this.fetchSponsorships()
  },
}
